import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageErrorPlaceholder from '../../../../../assets/imgs/image_error_placeholder.png';
import { DownloadIcon, WhiteRefresh } from '../../../../../assets/svgs/icons';
import styles from './styles.module.css';
export function ImageField({
  imageUrl,
  onDownloadImage,
  onGenerateAgain,
  onLoad,
  hasShamanSeal,
  setHasShamanSeal,
}) {
  const { t } = useTranslation()
  const undefinedImageUrl = imageUrl?.includes('undefined') || !imageUrl
  const [cacheKey, setCacheKey] = React.useState(Date.now())

  React.useEffect(() => {
    setCacheKey(Date.now())
  }, [])


  React.useEffect(() => {
    setCacheKey(Date.now())
  }, [imageUrl])

  const getImageUrlWithCacheBuster = () => {
    if (!imageUrl) return '';

    const separator = imageUrl.includes('?') ? '&' : '?';
    return `${imageUrl}${separator}t=${cacheKey}`;
  };

  // console.log('cache', cacheKey)

  return (
    <div className={styles.image_container}>
      {undefinedImageUrl && (
        <div className={styles.box_image}>
          <img
            key={cacheKey}
            src={ImageErrorPlaceholder + '?v=' + cacheKey}
            alt="placeholder"
            className={styles.image_error}
            style={{
              border: '4px solid #D9D9D9',
              maxHeight: 400
            }}
            onContextMenu={(e) => e.preventDefault()}
          />

        </div>
      )}
      {!undefinedImageUrl && (
        <div className={styles.box_image}>
          <img
            src={getImageUrlWithCacheBuster()}
            alt="generated image"
            className={styles.image}
            onContextMenu={(e) => e.preventDefault()}
            onLoad={onLoad}
          />

          <div
            className={styles.hover_button}
            onClick={onGenerateAgain}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <div
              style={{
                fontSize: 16,
                color: '#fff',
                fontWeight: 500,
                textAlign: 'center',
              }}
            >
              {t('new_publication_page_ia_step_fourth_re_generate')}
            </div>
            <div
              style={{
                marginBottom: 10,
              }}
            >
              <WhiteRefresh color={'#fff'} width={40} height={40} />
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          width: '100%'
        }}
      >
        {undefinedImageUrl && (
          <button
            className={styles.regenerate_error_button} onClick={onGenerateAgain}>
            <p style={{ fontSize: 14, fontWeight: 500, margin: 0 }}>
              {t('new_publication_page_ia_step_fourth_try_again')}
            </p>
          </button>
        )}
        {!undefinedImageUrl && (
          <button
            className={styles.download_button}
            onClick={onDownloadImage}
          >
            <DownloadIcon color={'#6A0098'} size={24} />
            <span>{t('new_publication_page_ia_step_fourth_download_art')}</span>
          </button>
        )}
      </div>
      {/* <div
        className={styles.shaman_seal_container}
        onClick={() => setHasShamanSeal(!hasShamanSeal)}
      >
        <input
          type="checkbox"
          checked={hasShamanSeal}
          onChange={(e) => setHasShamanSeal(e.target.checked)}
          className={styles.shaman_seal_checkbox}
        />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <span className={styles.shaman_seal_label}>
            {t('new_publication_page_ia_step_fourth_shaman_seal_checkbox')}
          </span>
          <span className={styles.shaman_seal_label} style={{ fontSize: '12px', fontWeight: 400 }}>
            {t('new_publication_page_ia_step_fourth_shaman_seal_description')}
          </span>
        </div>
      </div> */}
    </div>

  )
}



ImageField.propTypes = {
  imageUrl: PropTypes.string,
  legend: PropTypes.string,
  onCopyLegend: PropTypes.func.isRequired,
  onDownloadImage: PropTypes.func.isRequired,
  onGenerateAgain: PropTypes.func.isRequired,
};

export const ImageFieldMemoized = ImageField;
